<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Novo Encaminhamento p/ Acolhimento") }}</h1>

    <form @submit.prevent="submit" ref="addItem">
      <!--Bloco Responsável Familiar-->
      <div class="row">
        <!-- Template -->
        <form-select
          v-model="encaminhamento.pessoas_acolhimento"
          :multiple="true"
          label="Usuário(s)"
          :itens="usuariosAcolhimento"
          :required="true"
        />
        <form-select
          v-model="encaminhamento.tipo_id"
          label="Tipos de encaminhamento"
          grid="12"
          :itens="tipos"
          btn-icon="mdi mdi-plus"
          :required="true"
          :disabled="loadTipos"
          :loading="loadTipos"
        />

        <form-toggle
          v-model="showUnidadeExterna"
          grid="12"
          label="Para Unidade Externa?"
        />

        <form-select-input
          v-if="showUnidadeExterna == true && $store.state.user.role_details.name == 'Admin'"
          ajuda="Antes de realizar o cadastro de uma Unidade Externa, confirme com muita atenção: se o nome já extiste ou se sua pesquisa não retornou valor pela ausência de uma letra. O cadastro de Unidades Externas com nomes errados pode compromenter os dados gerados em relatórios. * Não é permitido acentos,(ç) cedilha e nenhum outro caracter especial no nome da Unidade."
          v-model="encaminhamento.unidade_destino_id"
          grid="6"
          :label="`Unidade de destino ${showUnidadeExterna ? 'externa' : ''}`"
          :itens="unidades"
          :placeholder="'DIGITE O NOME - UNIDADE DE DESTINO EXTERNA'"
          @insert="inserirUnidadeExterna"
          @change="getTecnicos(encaminhamento.unidade_destino_id)"
          :uppercase="true"
          :required="true"
          :disabled="loadUnidades"
          :loading="loadUnidades"
          ref="selectUnidadesExternas"
          :status="true"
          msgNaoEncontrado="Nenhuma Unidade Externa foi encontrada! Desejar cadastrar? Se sim, revise o nome e pressione em Cadastrar."
        />

        <form-select
          v-else
          v-model="encaminhamento.unidade_destino_id"
          :label="`Unidade de destino ${showUnidadeExterna ? 'externa' : ''}`"
          :grid="showUnidadeExterna ? '6' : '12'"
          :itens="unidades"
          :required="true"
          btn-icon="mdi mdi-plus"
          @input="
            getTecnicos(encaminhamento.unidade_destino_id);
            loadTecnicosUnidades = true;
            disabledFuncao = false;
            funcao_select = '';
          "
          :disabled="loadUnidades"
          :loading="loadUnidades"
        />
        <form-select
          v-if="!showUnidadeExterna"
          v-model="funcao_select"
          label="Selecione uma função"
          grid="6"
          :itens="funcoes"
          btn-icon="mdi mdi-plus"
          @input="getFuncao"
          :disabled="disabledFuncao"
          :loading="loadFuncao"
        />
        <!-- encaminhamento.unidade_destino_id ? false : true -->
        <form-select
          :disabled="loadUser"
          v-model="encaminhamento.user_destino_id"
          label="Destinatário"
          grid="6"
          :itens="listtecnicos"
          btn-icon="mdi mdi-plus"
          :loading="loadTecnicosUnidades"
        />
        <form-textarea-editor
          v-model="encaminhamento.descricao"
          grid="12"
          label="Descrição sumária do Encaminhamento"
          :required="true"
        />
        <form-file
          @submit="submitFile"
          multiple
          btn-text="Iniciar"
          :progress="progressCompleted"
        />
      </div>
      
      <div class="row pt-4 px-0 d-flex justify-content-end">
          <form-toggle
         grid="3"
          mt="0"
          v-model="encaminhamento.privado"
          label="Sigilo?"
        />
        <div class="col-auto px-2 text-right">
          <a class="btn btn-default" @click="$emit('voltar')">
            <i class="mdi mdi-arrow-left" />
          </a>
          <button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>

const DESCRICAO_PADRAO_CASA_PASSAGEM = [
  "<p>Encaminhamos, por meio deste, o(a) Sr.(a) __________________________________________, portador(a) do documento nº ________________________, para acolhimento institucional em Casa de Passagem, serviço destinado a usuários em situação de rua, conforme avaliação e acompanhamento da equipe técnica da Assistência Social.</p>",

  "<p><strong>Período de Permanência:</strong> O acolhimento terá início em 00/00/00, com permanência prevista até 00/00/00, podendo ser reavaliado pela equipe técnica conforme adesão às normas do serviço e acompanhamento socioassistencial.</p>",

  "<p><strong>Validade do Encaminhamento:</strong> Este encaminhamento é válido exclusivamente na data de sua emissão, não sendo aceito em data posterior.</p>",

  "<p><strong>Horário de Entrada:</strong> O horário de entrada na Casa de Passagem é às 19h, impreterivelmente. Não será permitida a entrada após esse horário.</p>",

  "<p><strong>Regras e Normas da Casa de Passagem:</strong> O usuário deverá estar ciente e de acordo com as seguintes normas do serviço:</p>",

  "<p>• A permanência está condicionada ao cumprimento integral das regras institucionais;</p>",

  "<p>• A partir de 2 (duas) faltas consecutivas, sem justificativa aceita pela equipe da Casa de Passagem, o usuário perderá automaticamente a vaga;</p>",

  "<p>• A partir de 3 (três) faltas alternadas, dentro do período de validade deste encaminhamento, sem justificativa, também se caracterizará perda da vaga;</p>",

  "<p>• É terminantemente proibido adentrar o local portando objetos cortantes, perfurantes ou quaisquer itens que ofereçam risco à integridade física dos demais usuários e da equipe;</p>",

  "<p>• É obrigatório manter comportamento respeitoso, preservando a convivência coletiva e o patrimônio do serviço;</p>",

  "<p>• Não é permitida a entrada na Casa de Passagem de usuários que se encontrem embriagados ou sob efeito de substâncias psicoativas;</p>",

  "<p>• O uso de álcool ou outras substâncias psicoativas nas dependências da Casa de Passagem é proibido;</p>",

  "<p>• O descumprimento das normas poderá resultar em desligamento imediato do serviço.</p>",

  "<p><strong>Acompanhamento Socioassistencial:</strong> O usuário permanecerá em acompanhamento pela rede socioassistencial, sendo orientado quanto aos seus direitos, deveres e possibilidades de encaminhamentos para outros serviços, conforme seu Plano de Acompanhamento Individual.</p>",

  "<p><strong>End:</strong> Rua Luís Lacava, 327 – Vila Bocaina</p>",

  "<p><strong>Ponto de Referência:</strong> RUA DO SENAI</p>",
].join("");

export default {
  props: ["acolhimento", "morph", "usuariosvinculados"],
  name: "Add",
  data() {
    return {
      encaminhamento: {
        unidade_destino_id: null,
        descricao: "",
        pessoas_acolhimento: [],
      },
      tecnicos: [],
      tecnicos_funcao: [],
      unidades: [],
      tipos: [],
      files: [],
      funcoes: [],
      funcao_select: "",
      loadUser: true,
      disabledFuncao: true,
      progressCompleted: 0,
      showUnidadeExterna: false,
      loadUnidades: true,
      loadFuncao: false,
      loadTipos: true,
      loadTecnicosUnidades: false,
      unidade: {
        nome: null,
        type: "",
        nome_tipo_unidade: "",
      },
    };
  },
  computed: {

    municipio() {
      return String(this.$store.state.municipio || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    unidadeTecnicoId() {
      return Number(
        this.$store.state.user?.tecnico?.unidade_id ?? 0
      );
    },

    devePreencherDescricaoCasaPassagem() {
      return (
        this.municipio === "develop" ||
        (this.municipio === "maua" && this.unidadeTecnicoId === 91)
      );
    },

    usuariosAcolhimento() {
      if (!this.acolhimento) return [];

      const usuarios = [];

      // Adiciona a pessoa acolhida
      if (this.acolhimento.id && this.acolhimento.nome_acolhido) {
        usuarios.push({
          id: this.acolhimento.id,
          value: this.acolhimento.nome_acolhido,
        });
      }

      // Adiciona pessoa(s) de referência, se houver
      if (Array.isArray(this.acolhimento.pessoaReferencia)) {
        this.acolhimento.pessoaReferencia.forEach((p) => {
          if (p.id && p.nome) {
            usuarios.push({ id: p.id, value: p.nome });
          }
        });
      }

      return usuarios;
    },
    listtecnicos() {
      const pessoas = this.tecnicos_funcao;
      
      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + (elem.role ?? 'Não informado'),
      }));
      return map;
    },
  },

  watch: {
    devePreencherDescricaoCasaPassagem: {
      immediate: true,
      handler(devePreencher) {
        const descricaoAtual = String(
          this.encaminhamento.descricao || ""
        ).trim();

        if (devePreencher && !descricaoAtual) {
          this.encaminhamento.descricao =
            DESCRICAO_PADRAO_CASA_PASSAGEM;
        }
      },
    },

    showUnidadeExterna: function () {
      this.encaminhamento.unidade_destino_id = null;
      this.getUnidades();
    },
  },

  mounted() {
    this.getUnidades();
    this.getTipos();
  },
  methods: {
    // privateFromOsasco() {
    //       const role_name = this.$store.state.user.role_details.name
    //         if (window.location.hostname == "osascosp.suasfacil.com.br" || window.location.hostname == 'suasfacil.host'|| window.location.hostname == 'sandbox.suasfacil.com.br' && role_name == 'Técnico(a) de Nível Superior') {
    //             this.encaminhamento.privado =  1;
    //         } else {
    //             this.encaminhamento.privado =  2;
    //         }
    //     },
    getFuncao() {
      this.loadTecnicosUnidades = true;

      this.tecnicos_funcao = this.tecnicos.filter((e) => {
        if (e.role == this.funcao_select) {
          return true;
        } else {
          return false;
        }
      });
      setTimeout(() => {
        this.encaminhamento.user_destino_id = null;
        this.loadTecnicosUnidades = false;
      }, 300);
    },
    submitFile(files) {
      this.files = files;
    },
    getTecnicos(unidade_id) {
      this.loadUser = true;
      this.loadFuncao = true;
      axios
        .get(`api/dashboard/tecnicos/get/externos/${unidade_id}`)
        .then((response) => {
          this.tecnicos = response.data;
          this.tecnicos_funcao = response.data;
          let array = this.tecnicos.map((e) => {
            return {
              id: e.role,
              value: e.role,
            };
          });
          this.funcoes = array.filter((obj, index, self) => {
            if (obj.id != "Admin") {
              return (
                index === self.findIndex((o) => JSON.stringify(o) === JSON.stringify(obj))
              );
            } else {
              return false;
            }
          });
        })
        .finally(() => {
          this.loadFuncao = false;
          this.loadUser = false;
          this.loadTecnicosUnidades = false;
        });
    },
    getUnidades() {
      const ue = this.showUnidadeExterna == 1 ? "UE - UNIDADE EXTERNA" : "";
      this.loadUnidades = true;
      axios
        .get(`api/dashboard/unidades/get/externas/${ue}`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadUnidades = false;
        });
    },
    getTipos() {
      this.loadTipos = true;
      axios
        .get(`api/dashboard/encaminhamento/tipos`)
        .then((response) => {
          this.tipos = response.data;
        })
        .finally(() => {
          this.loadTipos = false;
        });
    },
    setTipos(tipos) {
      this.tipos = tipos;
    },
    submit() {
      if (
        (this.showUnidadeExterna == 1 &&
          this.encaminhamento.unidade_destino_id == null) ||
        this.encaminhamento.unidade_destino_id == "" ||
        this.encaminhamento.unidade_destino_id == 0
      ) {
        swal.fire({
          title: "Algo não funcionou corretamente!",
          html: "UNIDADE EXTERNA não encontrada ou não foi cadastrada!",
          icon: "error",
        });
        return;
      }

      this.encaminhamento.acolhimento_crianca_id = this.acolhimento?.id;

      if (this.morph) {
        this.encaminhamento.morph = this.morph;
      }

      if (this.showUnidadeExterna == 1) {
        this.encaminhamento.unidade_externa = 1;
      }


      let formData = new FormData();

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("anexos[]", this.files[i]);
        }
      } else {
        formData.append("anexos", this.files);
      }

      for (var key in this.encaminhamento) {
        if (key == "morph" && this.encaminhamento.morph != undefined) {
          formData.append(key, this.encaminhamento[key]);
          formData.append("morph_id", this.morph.id);
          formData.append("morph_type", this.morph.type);
        } else {
          const isJsonField = ['pessoas_acolhimento'].includes(key);
          formData.append(key, isJsonField ? JSON.stringify(this.encaminhamento[key]) : this.encaminhamento[key]);
        }
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/encaminhamentos`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          if (this.morph != undefined) {
            this.$emit("reload");
          } else {
            this.$router.push(`/dashboard/encaminhamentos/edit/${response.data.data.id}`);
          }
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
    inserirUnidadeExterna(nome) {
      this.encaminhamento.unidade_destino_id = null;
      nome = nome
        .normalize("NFD")
        .replace(/([\u0300-\u036f])/g, "")
        .replace(/([^\w]+|\s+)/g, "-")
        .replace(/\-+/g, " ")
        .toUpperCase();

      this.loadUnidades = true;
      this.unidade.type = "UE - UNIDADE EXTERNA";
      this.unidade.nome = nome;
      this.unidade.nome_tipo_unidade = "UE - UNIDADE EXTERNA";

      axios
        .post("api/dashboard/unidades", this.unidade)
        .then((response) => {
          this.loadUnidades = true;
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });

          const unidade = {
            id: response.data.data.unidade.id,
            value: response.data.data.unidade.nome,
          };
          this.unidades.unshift(unidade);

          this.encaminhamento.unidade_destino_id = response.data.data.unidade.id;
          this.loadUnidades = false;

          this.getTecnicos(this.encaminhamento.unidade_destino_id);
        })
        .catch(() => {
          this.loadUnidades = false;
        })
        .finally(() => {
          this.loadUnidades = false;
        });
    },
  },
};
</script>
